import { useState, useEffect, useRef, } from "react";
import { useContext, useMemo } from "react";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Transmitter from "../components/Transmitter";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import Valve from "../components/Valve";
import "./FuelGasSystem.css";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import { PumpContext } from "../context/PumpContext"; 
import { ProcessContext } from "../context/ProcessContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";


import { trackPageVisit } from "../competency/PageTracker";
import TransmitterFaceplate from "../components/TransmitterFaceplate";





function ValveOutput({
    tag,
    value,
    x,
    y,
    r = 0,
    description = "Control Valve Opening"
}) {

    const [hover, setHover] = useState(false);
    const [showFaceplate, setShowFaceplate] = useState(false);

    return (
        <>
            {/* Hover */}
            {hover && (
                <div
                    style={{
                        position: "absolute",
                        left: x + 30,
                        top: y - 5,
                        background: "rgba(0,80,180,.85)",
                        color: "#fff",
                        padding: "5px 8px",
                        borderRadius: "4px",
                        border: "1px solid #4fc3ff",
                        fontSize: "11px",
                        zIndex: 9999,
                        pointerEvents: "none",
                        whiteSpace: "nowrap"
                    }}
                >
                    <strong>{tag}</strong><br />
                    {description}
                </div>
            )}

            {/* Original Valve Output */}
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => setShowFaceplate(true)}
                style={{
                    position: "absolute",
                    left: x,
                    top: y,

                    color: "lime",
                    background: "black",

                    fontSize: "10px",
                    padding: "1px 4px",

                    borderRadius: "4px",
                    border: "1px solid #555",

                    transform: `rotate(${r}deg)`,
                    transformOrigin: "center",

                    cursor: "pointer",

                    fontWeight: "bold",

                    minWidth: "22px",
                    textAlign: "center",

                    transition: "0.2s",
                    boxShadow: hover
                        ? "0 0 8px rgba(0,255,255,.7)"
                        : "none"
                }}
            >
                {Number(value).toFixed(1)} %
            </div>

            {showFaceplate && (
                <TransmitterFaceplate
                    tag={tag}
                    value={Number(value)}
                    unit="%"
                    min={0}
                    max={100}
                    HH={100}
                    H={90}
                    L={10}
                    LL={0}
                    description={description}
                    x={x + 35}
                    y={y + 20}
                    onClose={() => setShowFaceplate(false)}
                />
            )}
        </>
    );
}




function FuelGasSystem() {

    useEffect(() => {
    
      trackPageVisit("FuelGasSystem");
    
    }, []);
  
     const {  valves, toggleValve} = useContext(WellContext);

const [hoveredValve, setHoveredValve] = useState(null);
const {processData,  setProcessData} = useContext(ProcessContext);


     

  const DEFAULT_VALVES = {
  FCV_3201: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_3202: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_3203: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_3204: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_3205: { mode: "Manual", opening: 0, sp: "", pv: "" },


};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("FuelGasSystem_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_3201: { ...DEFAULT_VALVES.FCV_3201, ...parsed.FCV_3201 },
      FCV_3202: { ...DEFAULT_VALVES.FCV_3202, ...parsed.FCV_3202 },
      FCV_3203: { ...DEFAULT_VALVES.FCV_3203, ...parsed.FCV_3203 },
      FCV_3204: { ...DEFAULT_VALVES.FCV_3204, ...parsed.FCV_3204 },
      FCV_3205: { ...DEFAULT_VALVES.FCV_3205, ...parsed.FCV_3205 },


    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("FuelGasSystem_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };


  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};





const [panelPos, setPanelPos] = useState({ x: 0, y: 80 });
const [dragging, setDragging] = useState(false);
const offsetRef = useRef({ x: 0, y: 0 });

const handleMouseDown = (e) => {
  setDragging(true);

  offsetRef.current = {
    x: e.clientX - panelPos.x,
    y: e.clientY - panelPos.y,
  };
};

const handleMouseMove = (e) => {
  if (!dragging) return;

  setPanelPos({
    x: e.clientX - offsetRef.current.x,
    y: e.clientY - offsetRef.current.y,
  });
};

const handleMouseUp = () => {
  setDragging(false);
};

useEffect(() => {
  window.addEventListener("mousemove", handleMouseMove);
  window.addEventListener("mouseup", handleMouseUp);

  return () => {
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  };
}, [dragging]);




const tagStyle = {
      position: "absolute",
      top: -30,
      left: "50%",
      transform: "translateX(-50%)",

      background: "black",
      color: "#00ffcc",

      fontSize: "13px",
      fontWeight: "bold",

      padding: "3px 8px",
      borderRadius: "4px",

      border: "1px solid #555",

      whiteSpace: "nowrap",
      zIndex: 999
    };


// ================= RETREIVING OF DATA FROM OTHER PAGES VIA LOCAL STROAGE =================

  
            const { transmitters, flowOverrides } = usePlantStore();
            const TT_2906 = transmitters.TT_2906 || 0;
            const FIC_2906 = transmitters.FIC_2906 || 0;
            const PT_2906 = transmitters.PT_2906 || 0;
            const TT_2604 = transmitters.TT_2604 || 0;
            const FIC_2604 = transmitters.FIC_2604 || 0;
            const PT_2604 = transmitters.PT_2604 || 0;
            const TT_18004 = transmitters.TT_18004 || 0;
            const FIC_18004 = transmitters.FIC_18004 || 0;
            const PT_18004 = transmitters.PT_18004 || 0;






  const xv3201Open = !valves?.XV_3201;
  const xv3202Open = !valves?.XV_3202;
  const xv3203Open = !valves?.XV_3203;



  const FIC_3201 = FIC_2906;
  const TT_3201 = TT_2906;
  const PT_3201 = PT_2906;

  const FIC_3204 = FIC_18004;
  const TT_3204 = TT_18004;
  const PT_3204 = PT_18004;
  
  const FIC_3205 = FIC_2604;
  const TT_3205 = TT_2604;
  const PT_3205 = PT_2604;

  
   

   

    const FIC_3202 = 15.32 * (valveData?.FCV_3201?.opening || 0)/100;
    const PT_3202 = (valveData?.FCV_3201?.opening || 0)/100 > 0 ? 0.954 : 0.03;
    const TT_3202 = (valveData?.FCV_3201?.opening || 0)/100 > 0 ? 35 : 25;


    const FIC_32012 = xv3203Open ? FIC_3202*0.243 : 0;
    const PT_32012 = xv3203Open ? PT_3202 * 0.87 : 0.03;


  const PT_3203 =
  PT_3204 && PT_3205 && PT_32012
    ? (PT_3204 + PT_3205 + PT_32012) / 3
    : PT_3204 || PT_3205 || PT_32012 || 0.03;

  const TT_3203 =
  TT_3204 && TT_3205
    ? (TT_3204 + TT_3205) / 2
    : TT_3204 || TT_3205 || 0.03;
  
    

    const FIC_3208 = (FIC_3204 + FIC_3205 + FIC_32012) * (valveData?.FCV_3205?.opening || 0)/100;
    const FIC_3203 = ((FIC_3204 + FIC_3205 + FIC_32012) - FIC_3208) * 0.989;


    const FIC_3207 = (FIC_3202 + FIC_3201) * (valveData?.FCV_3202?.opening || 0)/100;


  const PT_3206 =
  PT_3201 && PT_3202
    ? (PT_3201 + PT_3202) / 2
    : PT_3201 || PT_3202 || 0.03;

  const TT_3206 =
  TT_3201 && TT_3202
    ? (TT_3201 + TT_3202) / 2
    : TT_3201 || TT_3202 || 0.03;
  
    const FIC_3206 = ((FIC_3201 + FIC_3202) - FIC_3207) * 0.989;






    const FIC_3209 = flowOverrides?.FIC_3209 ? 0 : (xv3202Open ? 1.54 * (valveData?.FCV_3204?.opening || 0)/100 : 0);
    const FIC_32010 = flowOverrides?.FIC_32010 ? 0 : (xv3201Open ? 1.54 * (valveData?.FCV_3204?.opening || 0)/100 : 0);
    const FIC_32011 = FIC_3209 + FIC_32010;








    
useEffect(() => {

  const current =
    PlantStore.get().transmitters;


  if (
    current.TT_3206 === TT_3206 &&
    current.FIC_3206 === FIC_3206 &&
    current.PT_3206 === PT_3206 &&
    current.FIC_3202 === FIC_3202 &&
    current.PT_3202 === PT_3202 &&
    current.TT_3203 === TT_3203 &&
    current.FIC_3203 === FIC_3203 &&
    current.PT_3203 === PT_3203 &&
    current.FIC_3207 === FIC_3207 &&
    current.FIC_3208 === FIC_3208 &&
    current.FIC_32011 === FIC_32011 
  ) {
    return;
  }


  PlantStore.set({
    transmitters: {

      ...current,
      TT_3206, FIC_3206, PT_3206, PT_3202, FIC_3202, TT_3203, FIC_3203, PT_3203, FIC_3207, FIC_3208, FIC_32011, 
    }
  });

}, [TT_3206, FIC_3206, PT_3206, PT_3202, FIC_3202, TT_3203, FIC_3203, PT_3203, FIC_3207, FIC_3208, FIC_32011,  ]);







  return (
    <div className="FuelGasSystem-container">

      {/* TITLE */}
      <h2
        style={{
          position: "absolute",
          top: "5px",
          left: "240px",
          color: "white",
          background: "rgb(30, 5, 250)",
          padding: "2px 326px",
          zIndex: 10,
        }}
      >
        FUEL GAS SYSTEM
      </h2>


 {/* =================SHUTDOWN VALVES ================= */}


      {/* XV-3202 */}
      <Valve
        className="XV-3202"
        tag="XV_3202"
        x={735}
        y={615}
        isClosed={valves.XV_3202}
        toggle={toggleValve}
      />

      {/* XV-3201 */}
      <Valve
        className="XV-3201"
        tag="XV_3201"
        x={918}
        y={504}
        isClosed={valves.XV_3201}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-3203 */}
      <Valve
        className="XV-3203"
        tag="XV_3203"
        x={448}
        y={304}
        isClosed={valves.XV_3203}
        toggle={toggleValve}
        r={90}
      />


      



      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-3201 */}
        <div
            style={{ position: "absolute", left: 400, top: 141}}
            onMouseEnter={() => setHoveredValve("FCV_3201")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_3201")}
          >

            {hoveredValve === "FCV_3201" && (
              <div style={tagStyle}>
                FCV_3201
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-3201">
                    
          <defs>
            <linearGradient id="metal_3201">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_3201)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_3201)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-3202 */}
        <div
            style={{ position: "absolute", left: 1070, top: 144}}
            onMouseEnter={() => setHoveredValve("FCV_3202")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_3202")}
          >

            {hoveredValve === "FCV_3202" && (
              <div style={tagStyle}>
                FCV_3202
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-3202">
                    
          <defs>
            <linearGradient id="metal_3202">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_3202)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_3202)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>

 

        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-3204 */}
        <div
            style={{ position: "absolute", left: 1000, top: 604}}
            onMouseEnter={() => setHoveredValve("FCV_3204")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_3204")}
          >

            {hoveredValve === "FCV_3204" && (
              <div style={tagStyle}>
                FCV_3204
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-3204">
                    
          <defs>
            <linearGradient id="metal_3204">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_3204)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_3204)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>

        
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-3205 */}
        <div
            style={{ position: "absolute", left: 1000, top: 276}}
            onMouseEnter={() => setHoveredValve("FCV_3205")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_3205")}
          >

            {hoveredValve === "FCV_3205" && (
              <div style={tagStyle}>
                FCV_3205
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-3205">
                    
          <defs>
            <linearGradient id="metal_3205">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_3205)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_3205)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>

        

        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 320 + index * 40
              }}
            />
          ))}

           {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 320 + index * 40
              }}
            />
          ))}




      {/* ================= CONTROL VALVE OUTPUTS ================= */}


      <ValveOutput
        value={Number(valveData?.FCV_3201?.opening || 0)}
        x={420}
        y={187}
      />


      <ValveOutput
        value={Number(valveData?.FCV_3202?.opening || 0)}
        x={1092}
        y={192}
      />


      <ValveOutput
        value={Number(valveData?.FCV_3204?.opening || 0)}
        x={1022}
        y={652}
      />

      <ValveOutput
        value={Number(valveData?.FCV_3205?.opening || 0)}
        x={1022}
        y={322}
      />



      <Transmitter
        tag="FIC_3201"
        value={[FIC_3201]}
        x={235}
        y={73}
        unit="SCF/M"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF DRY GAS FROM V-302 GAS OUTLET TO HIGH PRESSURE GAS SEPARATOR (V-504)"
      />


      <Transmitter
        tag="PT_3201"
        value={[PT_3201]}
        x={405}
        y={73}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF DRY GAS FROM V-302 GAS OUTLET TO HIGH PRESSURE GAS SEPARATOR (V-504)"
      />


      <Transmitter
        tag="TT_3201"
        value={[TT_3201]}
        x={545}
        y={73}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF DRY GAS FROM V-302 GAS OUTLET TO HIGH PRESSURE GAS SEPARATOR (V-504)"
      />

      <Transmitter
        tag="FIC_3202"
        value={[FIC_3202]}
        x={165}
        y={138}
        unit="SCF/M"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF HP GAS FROM EXTERNAL GAS METERING SKID TO HP GAS SEPARATOR (V-504)"
      />


      <Transmitter
        tag="PT_3202"
        value={[PT_3202]}
        x={295}
        y={138}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF HP GAS FROM EXTERNAL GAS METERING SKID TO HP GAS SEPARATOR (V-504)"
      />


      <Transmitter
        tag="TT_3202"
        value={[TT_3202]}
        x={545}
        y={138}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF HP GAS FROM EXTERNAL GAS METERING SKID TO HP GAS SEPARATOR (V-504)"
      />

      <Transmitter
        tag="FIC_3203"
        value={[FIC_3203]}
        x={135}
        y={252}
        unit="SCF/M"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF LP GAS FROM V-505 GAS OUTLET TO FLARE MAIN BURNER"
      />


      <Transmitter
        tag="PT_3203"
        value={[PT_3203]}
        x={235}
        y={252}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF LP GAS FROM V-505 GAS OUTLET TO FLARE MAIN BURNER"
      />


      <Transmitter
        tag="TT_3203"
        value={[TT_3203]}
        x={345}
        y={252}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF LP GAS FROM V-505 GAS OUTLET TO FLARE MAIN BURNER"
      />

      <Transmitter
        tag="FIC_3204"
        value={[FIC_3204]}
        x={135}
        y={382}
        unit="SCF/M"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF LP GAS FROM V-101 GAS OUTLET TO LOW PRESSURE GAS SEPARATOR (V-505)"
      />


      <Transmitter
        tag="PT_3204"
        value={[PT_3204]}
        x={235}
        y={382}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF LP GAS FROM V-101 GAS OUTLET TO LOW PRESSURE GAS SEPARATOR (V-505)"
      />


      <Transmitter
        tag="TT_3204"
        value={[TT_3204]}
        x={345}
        y={382}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF LP GAS FROM V-101 GAS OUTLET TO LOW PRESSURE GAS SEPARATOR (V-505)"
      />

      <Transmitter
        tag="FIC_3205"
        value={[FIC_3205]}
        x={135}
        y={482}
        unit="SCF/M"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF LP GAS FROM V-102 GAS OUTLET TO LOW PRESSURE GAS SEPARATOR (V-505)"
      />


      <Transmitter
        tag="PT_3205"
        value={[PT_3205]}
        x={235}
        y={482}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF LP GAS FROM V-102 GAS OUTLET TO LOW PRESSURE GAS SEPARATOR (V-505)"
      />


      <Transmitter
        tag="TT_3205"
        value={[TT_3205]}
        x={345}
        y={482}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF LP GAS FROM V-102 GAS OUTLET TO LOW PRESSURE GAS SEPARATOR (V-505)"
      />

      <Transmitter
        tag="FIC_3206"
        value={[FIC_3206]}
        x={1135}
        y={72}
        unit="SCF/M"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF HP GAS FROM V-504 GAS OUTLET TO HP MAIN FURNACE BURNER"
      />


      <Transmitter
        tag="PT_3206"
        value={[PT_3206]}
        x={1035}
        y={72}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF HP GAS FROM V-504 GAS OUTLET TO HP MAIN FURNACE BURNER"
      />


      <Transmitter
        tag="TT_3206"
        value={[TT_3206]}
        x={945}
        y={72}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF HP GAS FROM V-504 GAS OUTLET TO HP MAIN FURNACE BURNER"
      />

      <Transmitter
        tag="FIC_3207"
        value={[FIC_3207]}
        x={1005}
        y={140}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF HP GAS SEPARATOR (V-505) TO FLARE KNOCK OUT DRUM/FLARE"
      />

      <Transmitter
        tag="FIC_3208"
        value={[FIC_3208]}
        x={1075}
        y={275}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF LP GAS SEPARATOR (V-505) TO FLARE KNOCK OUT DRUM/FLARE"
      />

      <Transmitter
        tag="FIC_32011"
        value={[FIC_32011]}
        x={1105}
        y={599}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF CONDENSATE FROM V-505 AND V-504 TO SLOP TANK"
      />



            <LevelTransmitterIndicator
              tag="LT_3201"
              totalLevel={500}
              inflows={[(FIC_3204+FIC_3205)*0.121]}
              outflows={[FIC_3209]}
              inflowTags={["FIC_3204", "FIC_3205"]}
              outflowTags={["FIC_3209"]}
              responseFactor={0.05}
              columnX={591}
              columnY={387}
              columnWidth={85}
              columnHeight={180}
              textX={690}
              textY={440}
              showFlow={true}
              backgroundOpacity={0.00}
              liquidOpacity={0.2}
              service="water"
            />

            <LevelTransmitterIndicator
              tag="LT_3202"
              totalLevel={500}
              inflows={[(FIC_3201+FIC_3202)*0.061]}
              outflows={[FIC_32010]}
              inflowTags={["FIC_3201", "FIC_3202"]}
              outflowTags={["FIC_32010"]}
              responseFactor={0.05}
              columnX={885}
              columnY={247}
              columnWidth={89}
              columnHeight={180}
              textX={990}
              textY={370}
              showFlow={true}
              backgroundOpacity={0.00}
              liquidOpacity={0.2}
              service="water"
            />











    </div>
  );
}

export default FuelGasSystem;